import { client } from './utils'

export class CourseBundles {
  attach() {
    $('.delete-bundle').click(event => {
      const $target = $(event.currentTarget)
      const $row = $target.closest('tr')
      const bundleId = $target.data('bundle-id')
      const title = 'Delete Course Bundle'
      const message = 'Are you sure you want to delete this bundle?'
      const yesCallback = async () => {
        try {
          await client.post(
            `/account/admin_course_bundles.delete/-/${bundleId}/`
          )
          $.meDialog.topMessage(
            'The course bundle has been deleted',
            4000,
            'success'
          )
          $row.remove()
        } catch (error) {
          console.error(error)
          $.meDialog.topMessage(
            'An error occurred when trying to delete the course bundle',
            4000,
            'danger'
          )
        }
      }
      $.meDialog.yesno(title, message, yesCallback)
    })
  }
}
